import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTogglePromotionModalView } from '../../../../hooks/useTogglePromotionModalView';
import { PromotionButtonsContainer } from './styled';
import { AuthorButton } from './Buttons/AuthorButton';
import { PromotionButton } from './Buttons/PromotionButton';
import { PaidService } from '../../../../graphql/types';
import { getPromotionServiceIcon } from '../../../../utils/helpers/getPromotionServiceIcon';

export interface PromotionButtonsSectionProps {
  isAuthor: boolean;
  paidServices: PaidService[];
}

export const PromotionButtonsSection: React.FC<
  PromotionButtonsSectionProps
> = ({ isAuthor, paidServices }) => {
  const { t } = useTranslation();
  const { openCorrectView } = useTogglePromotionModalView();

  const onPromotionClickHandler = (serviceId: string) => {
    openCorrectView(`service_${serviceId}`);
  };

  const authorButtonsList = paidServices.map(service => ({
    id: service.id,
    price: t('pages.current_item.promotion.price', {
      price: Math.min(...service.options.map(o => o.price))
    }),
    onClickHandler: () => onPromotionClickHandler(service.id),
    icons: getPromotionServiceIcon(service.id),
    title: t(`pages.current_item.promotion.${service.id}`),
    description: t(`pages.current_item.promotion.${service.id}_description`)
  }));

  const filteredButtons = authorButtonsList.filter(
    ({ id }) => id !== 'balance_paid_ad'
  );

  return (
    <div data-cy="prom-section">
      <PromotionButtonsContainer
        $isAuthor={isAuthor}
        data-cy={`prom-section__container${!isAuthor ? '-not-author' : ''}`}
      >
        {filteredButtons.map(
          ({ title, icons, description, price, onClickHandler, id }) => {
            const ButtonComponent: React.ElementType = isAuthor
              ? AuthorButton
              : PromotionButton;
            const requiredProps = {
              title,
              icons,
              price,
              onClickHandler,
              isAuthor,
              id
            };

            return (
              <ButtonComponent
                key={id}
                {...requiredProps}
                {...(isAuthor ? { description } : {})}
              />
            );
          }
        )}
      </PromotionButtonsContainer>
    </div>
  );
};
